import FontSize from './FontSize';

export default FontSize;
